import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function Dashboard() {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios.get('https://testing.sttar.in/api/expressions_interest')
      .then(res => {
        setData(res.data);
      })
      .catch(err => {
        console.error('Error fetching data:', err);
      });
  }, []);

  return (
    <div>
      <h2>Dashboard</h2>
      <div style={{ overflowX: "auto" }} className='details'>
        <table className='dashboard-table'>
          <thead>
            <tr className='info-data'>
              <th>Name</th>
              <th>Partner Name</th>
              <th>Address</th>
              <th>Partner Address</th>
              <th>Mobile No</th>
              <th>Whatsapp No.</th>
              <th>Email</th>
              <th>Partner Email</th>
              <th>Tax Return Files</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>{item.partner_name}</td>
                <td>{item.address}</td>
                <td>{item.partner_address}</td>
                <td>{item.mobile_no}</td>
                <td>{item.whatsapp_no}</td>
                <td>{item.email}</td>
                <td>{item.partner_email}</td>
                <td>
                  {item.tax_return_file &&
                    JSON.parse(item.tax_return_file).map((fileName, fileIndex) => (
                      <div key={fileIndex}>
                        <a
                          href={`https://testing.sttar.in/storage/uploads/${fileName}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {fileName}
                        </a>
                      </div>
                    ))
                  }
                </td>
                
                <td>
                  <a href={`/view/${item.id}`} className="btn-color">
                    <button className="view-btn">View</button>
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
